<section>

    <div class="banner_content">
        <div class="banner_content_slider">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frinch_bg.png" width="100%" class="mob_franchise" alt="">

            <div class="form_content">
                <div class="row flex-column-reverse flex-lg-row">
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6">
                        
                    <!-- <form [formGroup]="admissionForm">
                        <div class="form">
                            <div class="form_title">Enquire Now</div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="First Name*"
                                    formControlName="fname" [ngClass]="{ 'is-invalid': submitted && f.fname.errors }" />
                                <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                        First Name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Last Name*" formControlName="lname"
                                    [ngClass]="{ 'is-invalid': submitted && f.lname.errors }" />
                                <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                        Last name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Email*" formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                        Email is required
                                    </span>
                                    <span class="text-danger msg_txt" *ngIf="f.email.touched && f.email.errors?.email">
                                        Enter a valid email address
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Mobile*"
                                            (keyup)="getMobileNO();" formControlName="mobile"
                                            [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                            <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                            <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>

                                        </div>
                                        <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                                    </div>
                                    <div class="form-group mt-1" *ngIf="otpInput">
                                        <input type="text" class="form-control" placeholder="Enter OTP*"
                                            (keyup)="verifyOTP();" formControlName="otp"
                                            [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                                        <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                            <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                                        </div>
                                        <div *ngIf="otp_ValidMsg" class="validMsg">OTP verified successfully</div>
                                        <div *ngIf="otp_inValidMsg" class="inValidMsg">please enter valid otp</div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Pin Code*"
                                            [(ngModel)]="selectedpincode" formControlName="pinCode"
                                            [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                                        <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback">
                                            <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                            <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                                                pincode.</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" #ddlcountry
                                            [(ngModel)]="selectedcountry" formControlName="country"
                                            (change)="selectCountry(ddlcountry.value)"
                                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                                            <option value="">Country*</option>
                                            <option value="{{country.Country_Name}}"
                                                *ngFor="let country of countryList">{{country.Country_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.country.touched || submitted) && f.country.errors?.required">
                                                Country is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedstate"
                                            formControlName="state" (change)="selectState($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                            <option value="">State/District*</option>
                                            <option value="{{state.State_Name}}" *ngFor="let state of stateList">
                                                {{state.State_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                                State/District is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedCity"
                                            formControlName="city" (change)="selectCity($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                            <option value="">City*</option>
                                            <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                                {{city.City_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                                City is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedDevice"
                                            formControlName="location" (change)="selectCentet(selectedDevice)"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                            <option value="">Location*</option>
                                            <option value="{{franchise.Franchisee_Code}}"
                                                *ngFor="let franchise of franchiseeList">{{franchise.Franchisee_Name}}
                                            </option>
                                        </select>
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.location.touched || submitted) && f.location.errors?.required">
                                                Location is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mt-2 captcha_content">
                                <label for="" class="lebel_text">Enter the text as displayed</label>
                                <div class="box">
                                    <div class="box-CAPTCHA" id="box-CAPTCHA">
                                        <div class="CAPTCHA" id="CAPTCHA">{{gen_captcha}}</div>
                                        <div class="captcha_content_flex">
                                            <input type="text" id="input" placeholder="Type CAPTCHA Here" maxlength="6">

                                            <div id="wrong" style="margin-left: 10px;color: #f00;"></div>
                                            <div id="done" style="margin-left: 10px;color: #080;"></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div class="form-group mt-0 d-flex justify-content-center">
                                <div class="submit_btn text-center" id="submit" (click)="validationForm()">Submit</div>
                            </div>

                        </div>
                    </form> -->
                <app-franchise-form></app-franchise-form>    
                
                </div>
                </div>
            </div>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_banner_logo.png" class="kidzee_banner_logo" alt="">
            <h1 class="white_text">Transform your<br>
                Preschool into</h1>

            <div class="banner_text">
                <div class="sub_text">200+ Kidzee across the country have elevated<br> themselves to Kidzee Elementary
                    School already!</div>
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" alt="">
            </div>
        </div>

        <div class="subMenu_content">
            <app-sub-menu></app-sub-menu>
        </div>
    </div>

    <div class="mobile_res">
        <div class="mobile_form">
        <app-franchise-form></app-franchise-form> 
    </div>
        <!-- <div id="carouselExampleControls1" class="carousel slide">
            <div class="carousel-inner carousel-bg">
                <div class="carousel-item active" routerLink="/admissions">
                    <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/mobile_home_banner.png"
                        class="d-block img-fluid slider_banner" alt="...">
                    <div class="banner_title_content">
                        <div class="banner_title">Build a foundation
                            for<br>a life time of <br>
                            learning
                        </div>
                    </div>
                    <div class="admission_open" routerLink="/admissions">
                        Admission Open
                    </div>
                    <div class="d-flex justify-content-center">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt=""
                            routerLink="/admissions">
                    </div>
                </div>

                <div class="carousel-item" routerLink="/partner-with-kidzee">
                    <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/banner_4_mobileRes.png"
                        class="d-block img-fluid slider_banner" alt="...">
                  
                    <div class="d-flex justify-content-center">
                    </div>
                </div>

            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls1"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls1"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div> -->

        <div class="banner_text">
            <div class="sub_text">200+ Kidzee across the country have elevated<br> themselves to Kidzee Elementary
                School already!</div>

        </div>

        <div class="form_content">
            <div class="row flex-column-reverse flex-lg-row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                    <>
                    <!-- <form action="" [formGroup]="admissionForm">
                        <div class="form">
                            <div class="form_title">Enquire Now</div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="First Name*"
                                    formControlName="fname"
                                    [ngClass]="{ 'is-invalid': submitted && f.fname.errors }">
                                <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                        First name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Last Name*"
                                    formControlName="lname"
                                    [ngClass]="{ 'is-invalid': submitted && f.lname.errors }">
                                <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                        Last name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Email*"
                                    formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                        Email is required
                                    </span>
                                    <span class="text-danger msg_txt"
                                        *ngIf="f.email.touched && f.email.errors?.email">
                                        Enter a valid email address
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Mobile*"
                                    (keyup)="getMobileNO();" formControlName="mobile"
                                    [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                    <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                    <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>
                                </div>
                                <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                            </div>
                            <div class="form-group mt-2" *ngIf="otpInput">
                                <input type="text" class="form-control" placeholder="Enter otp*"
                                    (keyup)="verifyOTP();" formControlName="otp"
                                    [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                                <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                    <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                                </div>
                                <div *ngIf="otp_ValidMsg" class="validMsg">otp verified successfully</div>
                                <div *ngIf="otp_inValidMsg" class="inValidMsg">please enter valid otp</div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Pin Code*"
                                    formControlName="pinCode"
                                    [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                                <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback">
                                    <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                    <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                                        pincode.</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" formControlName="state"
                                            (change)="selectState($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                            <option value="">State/District</option>
                                            <option value="{{state.State_Name}}"
                                                *ngFor="let state of stateList">
                                                {{state.State_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                                State/District is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" formControlName="city"
                                            (change)="selectCity($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                            <option value="">City</option>
                                            <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                                {{city.City_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                                City is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <div class="form-check">
                                    <input class="form-check-input" checked disabled type="checkbox" value=""
                                        id="flexCheckDefault">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        I state that I am ready with a min investment of INR 15 - 16 Lacs* & a
                                        min
                                        space
                                        of 2000-3000 sqft, and have read, understood and accepted your Privacy
                                        Policy
                                        and the Terms
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mt-2 d-flex justify-content-center">
                                <button class="submit_btn" (click)="validationForm();">Submit</button>
                            </div>
                        </div>
                        <div class="enroll_now text-center mt-5">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png"  alt="">
                    </div>
                    </form> -->

                    <!-- <form [formGroup]="admissionForm">
                        <div class="form">
                            <div class="form_title">Enquire Now</div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="First Name*"
                                    formControlName="fname" [ngClass]="{ 'is-invalid': submitted && f.fname.errors }" />
                                <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                        First Name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Last Name*" formControlName="lname"
                                    [ngClass]="{ 'is-invalid': submitted && f.lname.errors }" />
                                <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                        Last name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Email*" formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                        Email is required
                                    </span>
                                    <span class="text-danger msg_txt" *ngIf="f.email.touched && f.email.errors?.email">
                                        Enter a valid email address
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Mobile*"
                                            (keyup)="getMobileNO();" formControlName="mobile"
                                            [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                            <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                            <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>

                                        </div>
                                        <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                                    </div>
                                    <div class="form-group mt-1" *ngIf="otpInput">
                                        <input type="text" class="form-control" placeholder="Enter OTP*"
                                            (keyup)="verifyOTP();" formControlName="otp"
                                            [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                                        <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                            <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                                        </div>
                                        <div *ngIf="otp_ValidMsg" class="validMsg">OTP verified successfully</div>
                                        <div *ngIf="otp_inValidMsg" class="inValidMsg">please enter valid otp</div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Pin Code*"
                                            [(ngModel)]="selectedpincode" formControlName="pinCode"
                                            [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                                        <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback">
                                            <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                            <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                                                pincode.</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" #ddlcountry
                                            [(ngModel)]="selectedcountry" formControlName="country"
                                            (change)="selectCountry(ddlcountry.value)"
                                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                                            <option value="">Country*</option>
                                            <option value="{{country.Country_Name}}"
                                                *ngFor="let country of countryList">{{country.Country_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.country.touched || submitted) && f.country.errors?.required">
                                                Country is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedstate"
                                            formControlName="state" (change)="selectState($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                            <option value="">State/District*</option>
                                            <option value="{{state.State_Name}}" *ngFor="let state of stateList">
                                                {{state.State_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                                State/District is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedCity"
                                            formControlName="city" (change)="selectCity($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                            <option value="">City*</option>
                                            <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                                {{city.City_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                                City is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedDevice"
                                            formControlName="location" (change)="selectCentet(selectedDevice)"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                            <option value="">Location*</option>
                                            <option value="{{franchise.Franchisee_Code}}"
                                                *ngFor="let franchise of franchiseeList">{{franchise.Franchisee_Name}}
                                            </option>
                                        </select>
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.location.touched || submitted) && f.location.errors?.required">
                                                Location is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mt-2 captcha_content">
                                <label for="" class="lebel_text">Enter the text as displayed</label>
                                <div class="box">
                                    <div class="box-CAPTCHA" id="box-CAPTCHA">
                                        <div class="CAPTCHA" id="CAPTCHA">{{gen_captcha}}</div>
                                        <div class="captcha_content_flex">
                                            <input type="text" id="input" placeholder="Type CAPTCHA Here" maxlength="6">

                                            <div id="wrong" style="margin-left: 10px;color: #f00;"></div>
                                            <div id="done" style="margin-left: 10px;color: #080;"></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div class="form-group mt-0 d-flex justify-content-center">
                                <div class="submit_btn text-center" id="submit" (click)="validationForm()">Submit</div>
                            </div>

                        </div>
                    </form> -->

                </div>
            </div>
        </div>
    </div>

</section>
<!-- <section>
    <div class="mainDiv">
        <app-home-about-us></app-home-about-us>
    </div>
</section> -->
<section>
    <app-fab></app-fab>
</section>
<section>
    <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/day_care_bg_img.png" class="day_care_bg"
        alt="">
    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/objective_mobile_res.png" class="day_care_bg_mobile" alt="">
    <div class="mainDiv2">
        <div class="dayCareContent">
            <div class="row">
                <div class="col-md-6">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title day_care_color">
                                Objective <br>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/obj_bg.png" class="bottom_img_content" alt="">
                            </h1>
                            <div class="paragraph_content mt-2 white_color">
                                <li>Kidzee Elementary School extends the Kidzee Preschool experience into the elementary
                                    school segment.</li>
                                <li>Provide franchisees with academic support aligned to NEP and NCF standards, enabling
                                    them to deliver a robust elementary school curriculum.</li>
                                <li>Offer a strategic opportunity to expand into the primary/elementary education market
                                    up to Grade 8.</li>
                                <li>Protect the integrity of the in-house Mount Litera Zee School brand by ensuring all
                                    new K-5 (MLZS Primary) schools within the Kidzee network are signed up as Kidzee
                                    Elementary Schools.</li>
                            </div>
                        </div>
                        <!-- <div class="know_more">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/know_more.png" routerLink="/Daycare" alt="">
                        </div> -->
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="dayCardImg">
                        <div class="">
                            <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/obj_img.png" loading="lazy" alt="Kidzee Daycare"
                                class="schoolGirlImg responsive" align="center">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>

    <!-- <div class="mainDiv3">
        <h1 class="title">Our Pedagogy</h1>
        <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/baloon.png" class="baloon_img_content" alt="">
        <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/more_fish.png" class="more_fish_content" alt="">
        <div class="pentemindGroup">
            <div class="d-flex justify-content-center">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/pantamind_new_img.svg"
                    loading="lazy" class="pentemindgroupImg responsive" align="center" alt="pentemind">
            </div>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bird.png" class="bird_img_content" alt="">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/circal.png" class="circal_img_content" alt="">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/right_circal.png" class="right_circal_img_content" alt="">
        </div>
        <div class="pentamind_content text-center">
            <h6 class="text-center"><b>Péntemind - The Learning Minds</b>, our pedagogy nurtures the ‘Learning Minds’ in
                every child. It shapes the child’s overall development in a fun and <b>inspiring manner</b>.</h6>
        </div>
        <div class="pentemind_content d-flex justify-content-center mt-2">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/know_more.png" routerLink="/pentemind" alt="">
        </div>
    </div> -->
</section>
<section>
    <div class="mainDiv21">
        <!-- <h1 class="title">The KES Advantage</h1> -->
        <div class="dayCareContent1">
            <h1 class="title">The KES Advantage</h1>
            <div class="row flex-column-reverse flex-lg-row">
                <div class="col-md-12">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title text-center">
                            </h1>
                            <div class="subTitle text-center">
                            </div>
                            <div class="paragraph_content mt-2">
                                <div class="row para_text">
                                    <div class="col-md-2 d_content border_left">
                                        <p>India's largest
                                            preschool chain</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p> Proven
                                            business model</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p>Market leader with a strong brand recall & brand lineage of 20+ years</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p>Most awarded preschool in
                                            the category</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left" style="color: #6D2A93;">
                                        <p>4 layers of support</p>
                                    </div>
                                    <div class="col-md-2 d_content" style="color: #6D2A93;">
                                        <p>Most advanced
                                            curriculum</p>
                                    </div>
                                </div>

                                <div class="row para_text mt-2">
                                    <div class="col-md-2 d_content border_left">
                                        <p> Best-in class pedagogy</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p>Operational and Academic
                                            Support</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p>Training</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left">
                                        <p>E-Kidzee</p>
                                    </div>
                                    <div class="col-md-2 d_content border_left" style="color: #6D2A93;">
                                        <p>Layout plan</p>
                                    </div>
                                    <div class="col-md-2 d_content" style="color: #6D2A93;">
                                        <p>Project support</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<section>
    <div class="mainDiv5">
        <app-faqs></app-faqs>
    </div>
</section>
<section>
    <div class="mainDiv6">
        <div class="blogsContent">
            <app-blogs></app-blogs>
        </div>
    </div>
</section>
<app-slider-parents></app-slider-parents>
<app-footer></app-footer>